import { randomId } from '@mantine/hooks';
import { ResourceType } from '../../../../../../resource/enumerations/ResourceType';
import VersionService from '../../../VersionService';
import { ActivityReferenceCreatorFunction } from '../ActivityReferenceCreatorDialog';

const functionImageSvg =
    '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-sitemap"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 15m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" /><path d="M15 15m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" /><path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" /><path d="M6 15v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1" /><path d="M12 9l0 3" /></svg>';

export class ActivityReferencePaletteProvider {
    /**
     * @param {any} bpmnFactory
     * @param {any} create
     * @param {any} elementFactory
     * @param {any} translate
     * @param {any} palette
     * @param {any} translate
     * @param {VersionService} versionService
     * @param {string} versionId
     */
    constructor(bpmnFactory, create, elementFactory, palette, translate, versionService, versionId) {
        this.bpmnFactory = bpmnFactory;
        this.create = create;
        this.elementFactory = elementFactory;
        this.translate = translate;
        this.versionService = versionService;
        this.versionId = versionId;

        palette.registerProvider(this);
    }

    getPaletteEntries(/** @type {any} */ element) {
        const { bpmnFactory, create, elementFactory, translate, versionService, versionId } = this;
        // @ts-expect-error
        const calcVersionId = versionService.getVersionId();

        function createTask() {
            return function (/** @type {any} */ event) {
                const id1 = randomId().replace('mantine-', '').slice(0, 4);
                const id2 = randomId().replace('mantine-', '').slice(0, 4);
                ActivityReferenceCreatorFunction(versionId ?? calcVersionId, (objectId) => {
                    const businessObject = bpmnFactory.create('bpmn:Task');
                    businessObject.id = `Activities_Reference_${id1}`;
                    businessObject.objectId = objectId;
                    businessObject.resourceType = ResourceType.ACTIVITIES;
                    const shape = elementFactory.createShape({
                        id: `Activities_Reference_${id2}`,
                        width: 150,
                        height: 130,
                        type: 'bpmn:Task',
                        businessObject,
                    });
                    create.start(event, shape);
                });
            };
        }

        return {
            'create.activities-block': {
                group: 'activity',
                html: `<div class="entry">${functionImageSvg}</div>`,
                title: translate('Create Activities reference block'),
                action: {
                    dragstart: createTask(),
                    click: createTask(),
                },
            },
        };
    }
}

ActivityReferencePaletteProvider.$inject = [
    'bpmnFactory',
    'create',
    'elementFactory',
    'palette',
    'translate',
    'versionService',
];
